import * as Styled from "./style";
import { BreadcrumbsListBlock } from "~/components/blocks/product/common/blocks/breadcrumbs-list-block";
import { ProductBanner } from "~/components/blocks/product/common/blocks/product-banner";
import { ProductDescription } from "~/components/blocks/product/common/blocks/product-description";
import { BannerItem } from "~/components/blocks/product/common/blocks/product-related-items/collection-banner-item";
import { CollectionItem } from "~/components/blocks/product/common/blocks/product-related-items/collection-item";
import { RecommendItem } from "~/components/blocks/product/common/blocks/product-related-items/recommend-item";
import { ProductTitle } from "~/components/blocks/product/common/blocks/product-title";
import { VideoStageSeasonTab } from "~/components/blocks/product/common/video-stage-season/video-stage-season-tab";
import type { VideoStageSeasonType } from "~/components/blocks/product/type-guard";

type VideoStageSeasonProps = {
  videoStageSeasonData: VideoStageSeasonType;
};

export const VideoStageSeason = (props: VideoStageSeasonProps) => {
  const { videoStageSeasonData } = props;

  return (
    <>
      <ProductBanner videoData={videoStageSeasonData} />

      <Styled.DivProductTitlePadding>
        <ProductTitle videoData={videoStageSeasonData} />
        <ProductDescription videoData={videoStageSeasonData} />
        <VideoStageSeasonTab videoData={videoStageSeasonData} />
      </Styled.DivProductTitlePadding>

      <Styled.DivProductItemsFlexContainer>
        <RecommendItem />
        <BannerItem bannerType="scratch" videoData={videoStageSeasonData} />
        <BannerItem bannerType="onlineCrane" videoData={videoStageSeasonData} />
        <CollectionItem collectionType="videos" videoData={videoStageSeasonData} />
        <CollectionItem collectionType="books" videoData={videoStageSeasonData} />
        <BannerItem bannerType="mono" videoData={videoStageSeasonData} />
      </Styled.DivProductItemsFlexContainer>

      <BreadcrumbsListBlock videoData={videoStageSeasonData} />
    </>
  );
};
